import { render, staticRenderFns } from "./credit.vue?vue&type=template&id=694ea245&scoped=true"
import script from "./credit.vue?vue&type=script&lang=js"
export * from "./credit.vue?vue&type=script&lang=js"
import style0 from "./credit.vue?vue&type=style&index=0&id=694ea245&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694ea245",
  null
  
)

export default component.exports